import Id from './Id';
import Name from './Name';
import Status from './Status';
import Type from './Type';
import User from './User';
import DeputyUser from './DeputyUser';
import Created from './Created';
import Updated from './Updated';
import Country from './Country';
import County from './County';
import Address from './Address';
import PostalCode from './PostalCode';
import City from './City';

export const labels = {
  Id: 'Id',
  Name: 'Név',
  Status: 'Státusz',
  Type: 'Típus',
  User: 'Képviselő',
  DeputyUser: 'Képviselő helyettes',
  Country: 'Ország',
  County: 'Megye',
  PostalCode: 'Irányítószám',
  City: 'Város',
  Address: 'Cím',
  Updated: 'Módosítva',
  Created: 'Létrehozva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'Status',
}, {
  value: 'Type',
}, {
  value: 'User',
}, {
  value: 'DeputyUser',
}, {
  value: 'Country'
}, {
  value: 'County'
}, {
  value: 'PostalCode'
}, {
  value: 'City'
}, {
  value: 'Address',
}, {
  value: 'Created',
}, {
  value: 'Updated',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'Status',
}, {
  value: 'Type',
}, {
  value: 'Created',
}, {
  value: 'Updated',
}];

export const defaultSort = {
  prop: Name.propName,
  order: 'ascending'
};

export default {
  Id,
  Name,
  Status,
  Type,
  User,
  DeputyUser,
  Country,
  County,
  PostalCode,
  City,
  Address,
  Created,
  Updated,
};
